import { directive as vClickOutside } from "vue3-click-away";

const GlobalDirectives = {
  install(app) {
    app.directive("click-outside", vClickOutside);  }
};

export default GlobalDirectives;
